
const BetaBanner = (props) => {

    return (
        <div style={{
            backgroundColor: "#fff3cd", 
            borderBottom: "2px solid var(--color-warning)",
            borderTop: "2px solid var(--color-warning)",
            padding: "16px 0",
            fontSize: "15px",
            color: "#856404",
            fontWeight: "500"
        }}
             className={"text-center"}>
            <div className="container-fluid">
                <span className="fw-bold me-2" style={{color: "#664d03"}}>⚠️ Beta Test Site:</span>
                This environment tests new features and may contain issues. For a more stable experience, please return to our main
                <a 
                    href="https://portal.palatium.care/?from=beta" 
                    target="_self" 
                    className="text-decoration-none fw-bold ms-1" 
                    rel="noreferrer"
                    style={{color: "var(--color-primary)", textDecoration: "underline !important"}}
                    onClick={(e) => {
                        // Optional: Add analytics tracking for beta-to-prod transitions
                        if (window.gtag) {
                            window.gtag('event', 'beta_to_production', {
                                'event_category': 'navigation',
                                'event_label': 'beta_banner_link'
                            });
                        }
                    }}
                >
                    Portal Site
                    <i className="fe fe-external-link ms-1" style={{fontSize: "13px"}}></i>
                </a>
            </div>
        </div>
    );
};

export default BetaBanner;